import * as types from "../constants/ActionTypes";

export function addError(msg) {
    return {
        type: types.NEW_ERROR,
        msg
    };
}

export function clearErrors(index) {
    return {
        type: types.CLEAR_ERRORS,
        index
    };
}


// WEBPACK FOOTER //
// ./src/store/actions/ErrorActions.js